import { Form, FormInstance, Select, Typography } from "antd";
import Arrowdown from "../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as PlusGradientIcon } from "../../../common/images/svg/PlusGradient.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";

const { Option } = Select;

interface ISelectBeneficiaryProps {
  isTablet: boolean;
  form: FormInstance<any>;
  listBeneficiary: any[];
  beneficiarySelected: any;
  setBeneficiarySelected: React.Dispatch<any>;
  setWalletSelected: React.Dispatch<any>;
  setBankAccountSelected: React.Dispatch<any>;
  paramsBeneficiary: {
    start: number;
    end: number;
  };
  setParamsBeneficiary: React.Dispatch<
    React.SetStateAction<{
      start: number;
      end: number;
    }>
  >;
  setStepNewBeneficiary: React.Dispatch<React.SetStateAction<number | null>>;
  handleChangeBeneficiary?: () => void
}

const SelectBeneficiary = (props: ISelectBeneficiaryProps) => {
  const {
    isTablet,
    form,
    listBeneficiary,
    beneficiarySelected,
    setBeneficiarySelected,
    setWalletSelected,
    setBankAccountSelected,
    paramsBeneficiary,
    setParamsBeneficiary,
    setStepNewBeneficiary,
    handleChangeBeneficiary,
  } = props;

  return (
    <div>
      <div className="input-recipient">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: isTablet ? 10 : 12,
            width: "100%",
          }}
        >
          <Form.Item
            style={{ width: "100%" }}
            label="Beneficiary"
            name="beneficiary"
            validateTrigger="onBlur"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select
              showSearch
              className="select-recipient"
              popupClassName="select-beneficiary"
              placeholder="Choose a recipient"
              suffixIcon={<ArrowIcon />}
              disabled={!listBeneficiary.length}
              optionLabelProp="label"
              onChange={(id) => {
                const selected = listBeneficiary?.find(
                  (item: any) => item.id === id
                );
                setBeneficiarySelected(selected);
                setWalletSelected(null);
                setBankAccountSelected(null);
                form?.resetFields([
                  "beneficiary_wallet_address",
                  "beneficiary_bank_account",
                ]);
                if (handleChangeBeneficiary) {
                  handleChangeBeneficiary();
                }
              }}
              filterOption={(input, option: any) => {
                const beneficiary = listBeneficiary.find(
                  (w) => w.id === option.value
                );
                return (
                  beneficiary?.name
                    ?.toLowerCase()
                    .includes(input.toLowerCase()) ||
                  beneficiary?.fullName
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                );
              }}
            >
              {Array.isArray(listBeneficiary) &&
                listBeneficiary.map((item: any) => (
                  <Option
                    key={item.id}
                    value={item.id}
                    label={
                      <span className="ant-select-custom-value-sendmoney">
                        {item.fullName}
                      </span>
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span className="ant-select-custom-value-sendmoney">
                        {item.fullName}
                      </span>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          {item.name}
                        </span>
                        <div className="dot-transaction"></div>
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          {item.country}
                        </span>
                      </div>
                    </div>
                    {beneficiarySelected?.id === item.id && <CheckSelectIcon />}
                  </Option>
                ))}
              {(listBeneficiary.length === paramsBeneficiary.end || listBeneficiary.length === (paramsBeneficiary.end + 1)) && (
                <Option key="load-more" disabled>
                  <span
                    style={{
                      fontSize: isTablet ? 12 : 14,
                      color: "rgba(29, 171, 241, 1)",
                      fontWeight: 500,
                      cursor: "pointer",
                      height: "66px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setParamsBeneficiary((prev) => ({
                        ...prev,
                        end: prev.end + 10,
                      }));
                    }}
                  >
                    Load more <img src={Arrowdown} />
                  </span>
                </Option>
              )}
            </Select>
          </Form.Item>
          {!listBeneficiary.length && (
            <Typography
              style={{
                fontSize: isTablet ? 10 : 12,
                fontWeight: 400,
                color: "#EC3333",
              }}
            >
              {"You haven't added a sender yet. Click 'Add' to create one"}
            </Typography>
          )}
        </div>
        <div
          className="button-add-new-recipient"
          onClick={() => setStepNewBeneficiary(1)}
        >
          <PlusGradientIcon />
        </div>
      </div>
      {beneficiarySelected ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            marginTop: 8,
          }}
        >
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Company name: {beneficiarySelected?.fullName}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Reg. No: {beneficiarySelected?.regNo}
          </Typography>
          <Typography
            style={{
              fontSize: isTablet ? 12 : 14,
              fontWeight: 500,
              color: "white",
            }}
          >
            Country: {beneficiarySelected?.country}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export default SelectBeneficiary;
